import { groupValidators } from '@framework/ui/Organisms/FinalForm/validators/helpers';
import { validateMaxLength } from '@framework/ui/Organisms/FinalForm/validators/validateMaxLength';
import { validateMinLength } from '@framework/ui/Organisms/FinalForm/validators/validateMinLength';
import { IParams, validateRequiredField } from '@framework/ui/Organisms/FinalForm/validators/validateRequiredField';
import { IValidationError } from '@framework/ui/Organisms/FinalForm/validators/interfaces/ValidationError';
import {
  IFieldData, IValuesMap,
} from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/ManagePortfoliosModal/ManagePortfoliosModal';

const duplicateMessage = 'A Portfolio with this name already exists';

export const validateDuplicate = (params: IParams, fieldsData: IFieldData[]): IValidationError => {
  const duplicates = fieldsData.filter((metaData) => metaData.value === params.value);
  if (duplicates.length < 2) return null;

  const metaDataId = params.fieldName;
  const duplicateOfParam = duplicates.find((duplicate) => duplicate.id === metaDataId);
  const indexOfParam = duplicates.indexOf(duplicateOfParam);
  if (indexOfParam > 0) return { [params.fieldName]: duplicateMessage };

  return null;
};

export default (values: IValuesMap, fieldsData: IFieldData[]): object | null => {
  const validators = [];
  const fieldNames = Object.keys(values);

  fieldNames.forEach((fieldName) => {
    validators.push(
      validateRequiredField({
        fieldName,
        fieldCaption: 'Portfolio name',
        value: values[fieldName],
      }),
      validateMinLength({
        fieldName,
        fieldCaption: 'Portfolio name',
        value: values[fieldName],
        length: 3,
      }),
      validateMaxLength({
        fieldName,
        fieldCaption: 'Portfolio name',
        value: values[fieldName],
        length: 50,
      }),
      validateDuplicate({
        fieldName,
        value: values[fieldName],
      }, fieldsData),
    );
  });

  return groupValidators(...validators);
};
